((app) => {

    app.constant("_investmentAccountStatuses",
        [
            {
                name: "AwaitingFunds",
                toString() {
                    return "Awaiting Funds";
                }
            },
            {
                name: "SentToCustodian",
                toString() {
                    return "Sent to Custodian";
                }
            },
            {
                name: "AwaitingApproval",
                toString() {
                    return "Awaiting Approval";
                }
            },
            {
                name: "OKToTrade",
                toString() {
                    return "OK To Trade";
                }
            },
            {
                name: "AddedToTradeSheet",
                toString() {
                    return "Added to Trade Sheet";
                }
            },
            {
                name: "Invested",
                toString() {
                    return "Invested";
                }
            },
        ]);

})(window.app);